import {
  GETAYURVEDICOPDPAINASSESSMENT,
  CREATEAYURVVEDICOPDPAINASSESSMENT,
  UPDATEAYURVEDICOPDPAINASSESSMENT,
  DELETEAYURVEDICOPDPAINASSESSMENT,

  GETSETUPAYURVEDICOPDBODYCHART,
  CREATESETUPAYURVEDICOPDBODYCHART,
  UPDATESETUPAYURVEDICOPDBODYCHART,
  DELETESETUPAYURVEDICOPDBODYCHART,

  CREATEAYURVVEDICOPDCHIEFSYMTOMPS,
  GETAYURVEDICOPDCHIEFSYMTOMPS,
  UPDATEAYURVEDICOPDCHIEFSYMTOMPS,
  DELETEAYURVEDICOPDCHIEFSYMTOMPS,

  GETAYURVEDICOPDASSOCIATEDSYMTOMPS,
  CREATEAYURVVEDICOPDASSOCIATEDSYMTOMPS,
  UPDATEAYURVEDICOPDASSOCIATEDSYMTOMPS,
  DELETEAYURVEDICOPDASSOCIATEDSYMTOMPS,

  GETAYURVEDICOPDPRESENTILLCOMORBIDITY,
  CREATEAYURVVEDICOPDPRESENTILLCOMORBIDITY,
  UPDATEAYURVEDICOPDPRESENTILLCOMORBIDITY,
  DELETEAYURVEDICOPDPRESENTILLCOMORBIDITY,

  GETAYURVEDICOPDFAMILYSYMTOMPS,
  CREATEAYURVVEDICOPDFAMILYSYMTOMPS,
  UPDATEAYURVEDICOPDFAMILYSYMTOMPS,
  DELETEAYURVEDICOPDFAMILYSYMTOMPS,

  GETAYURVEDICOPDFAMILYCOMORBIDITY,
  CREATEAYURVVEDICOPDFAMILYCOMORBIDITY,
  UPDATEAYURVEDICOPDFAMILYCOMORBIDITY,
  DELETEAYURVEDICOPDFAMILYCOMORBIDITY,

  GETAYURVEDICOPDPRESENTCOMORILLNESS,
  CREATEAYURVVEDICOPDPRESENTCOMORILLNESS,
  UPDATEAYURVEDICOPDPRESENTCOMORILLNESS,
  DELETEAYURVEDICOPDPRESENTCOMORILLNESS,

  GETAYURVEDICOPDPASTILLNESS,
  CREATEAYURVVEDICOPDPASTILLNESS,
  UPDATEAYURVEDICOPDPASTILLNESS,
  DELETEAYURVEDICOPDPASTILLNESS,

  GETAYURVEDICOPDFAMILYILLNESS,
  CREATEAYURVVEDICOPDFAMILYILLNESS,
  UPDATEAYURVEDICOPDFAMILYILLNESS,
  DELETEAYURVEDICOPDFAMILYILLNESS,

  GETAYURVEDICOPDCOMPLAINTAPPETITE,
  CREATEAYURVVEDICOPDCOMPLAINTAPPETITE,
  UPDATEAYURVEDICOPDCOMPLAINTAPPETITE,
  DELETEAYURVEDICOPDCOMPLAINTAPPETITE,
  GETAYURVEDICOPDCOMPLAINTDIGESTIVETRACT,
  CREATEAYURVVEDICOPDCOMPLAINTDIGESTIVETRACT,
  UPDATEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT,
  DELETEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT,
  GETAYURVEDICOPDCOMPLAINTBOWEL,
  CREATEAYURVVEDICOPDCOMPLAINTBOWEL,
  UPDATEAYURVEDICOPDCOMPLAINTBOWEL,
  DELETEAYURVEDICOPDCOMPLAINTBOWEL,
  GETAYURVEDICOPDCOMPLAINTSLEEP,
  CREATEAYURVVEDICOPDCOMPLAINTSLEEP,
  UPDATEAYURVEDICOPDCOMPLAINTSLEEP,
  DELETEAYURVEDICOPDCOMPLAINTSLEEP,
  GETAYURVEDICOPDCOMPLAINTADDICTIONS,
  CREATEAYURVVEDICOPDCOMPLAINTADDICTIONS,
  UPDATEAYURVEDICOPDCOMPLAINTADDICTIONS,
  DELETEAYURVEDICOPDCOMPLAINTADDICTIONS,
  GETAYURVEDICOPDCOMPLAINTHIGHRISK,
  CREATEAYURVVEDICOPDCOMPLAINTHIGHRISK,
  UPDATEAYURVEDICOPDCOMPLAINTHIGHRISK,
  DELETEAYURVEDICOPDCOMPLAINTHIGHRISK,
  GETAYURVEDICOPDCOMPLAINTPOSITIONOFWORK,
  CREATEAYURVVEDICOPDCOMPLAINTPOSITIONOFWORK,
  UPDATEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK,
  DELETEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK,
  GETAYURVEDICOPDCOMPLAINTNATUREOFWORK,
  CREATEAYURVVEDICOPDCOMPLAINTNATUREOFWORK,
  UPDATEAYURVEDICOPDCOMPLAINTNATUREOFWORK,
  DELETEAYURVEDICOPDCOMPLAINTNATUREOFWORK,
  GETAYURVEDICOPDCOMPLAINTALLOPATHICMEDI,
  CREATEAYURVVEDICOPDCOMPLAINTALLOPATHICMEDI,
  UPDATEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI,
  DELETEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI,
  GETAYURVEDICOPDCOMPLAINTAYURVDAMEDI,
  CREATEAYURVVEDICOPDCOMPLAINTAYURVDAMEDI,
  UPDATEAYURVEDICOPDCOMPLAINTAYURVDAMEDI,
  DELETEAYURVEDICOPDCOMPLAINTAYURVDAMEDI,
  GETAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI,
  CREATEAYURVVEDICOPDCOMPLAINTHOMEOATHYMEDI,
  UPDATEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI,
  DELETEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI,
  GETAYURVEDICOPDCOMPLAINTOTHERMEDI,
  CREATEAYURVVEDICOPDCOMPLAINTOTHERMEDI,
  UPDATEAYURVEDICOPDCOMPLAINTOTHERMEDI,
  DELETEAYURVEDICOPDCOMPLAINTOTHERMEDI,
  GETAYURVEDICOPDCOMPLAINTANXIETY,
  CREATEAYURVVEDICOPDCOMPLAINTANXIETY,
  UPDATEAYURVEDICOPDCOMPLAINTANXIETY,
  DELETEAYURVEDICOPDCOMPLAINTANXIETY,
  GETAYURVEDICOPDCOMPLAINTDEPRESSION,
  CREATEAYURVVEDICOPDCOMPLAINTDEPRESSION,
  UPDATEAYURVEDICOPDCOMPLAINTDEPRESSION,
  DELETEAYURVEDICOPDCOMPLAINTDEPRESSION,
  GETAYURVEDICOPDCOMPLAINTIRRITABIILTY,
  CREATEAYURVVEDICOPDCOMPLAINTIRRITABIILTY,
  UPDATEAYURVEDICOPDCOMPLAINTIRRITABIILTY,
  DELETEAYURVEDICOPDCOMPLAINTIRRITABIILTY,
  GETAYURVEDICOPDCOMPLAINTEUPHORIA,
  CREATEAYURVVEDICOPDCOMPLAINTEUPHORIA,
  UPDATEAYURVEDICOPDCOMPLAINTEUPHORIA,
  DELETEAYURVEDICOPDCOMPLAINTEUPHORIA,
  GETAYURVEDICOPDCOMPLAINTOBSESSION,
  CREATEAYURVVEDICOPDCOMPLAINTOBSESSION,
  UPDATEAYURVEDICOPDCOMPLAINTOBSESSION,
  DELETEAYURVEDICOPDCOMPLAINTOBSESSION,
  GETAYURVEDICOPDCOMPLAINTNEUROSIS,
  CREATEAYURVVEDICOPDCOMPLAINTNEUROSIS,
  UPDATEAYURVEDICOPDCOMPLAINTNEUROSIS,
  DELETEAYURVEDICOPDCOMPLAINTNEUROSIS,
  GETAYURVEDICOPDCOMPLAINTDEPERSONALIZATION,
  CREATEAYURVVEDICOPDCOMPLAINTDEPERSONALIZATION,
  UPDATEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION,
  DELETEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION,
  GETAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE,
  CREATEAYURVVEDICOPDCOMPLAINTMENSTRUALCYCLE,
  UPDATEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE,
  DELETEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE,
  GETAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY,
  CREATEAYURVVEDICOPDCOMPLAINTNATUREOFDELIVERY,
  UPDATEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY,
  DELETEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY,

  GETAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST,
  CREATEAYURVVEDICOPDCOMPLAINTOCCUPATIONALHIST,
  UPDATEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST,
  DELETEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST,

  GETAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST,
  CREATEAYURVVEDICOPDCOMPLAINTGYNECOLOGICHIST,
  UPDATEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST,
  DELETEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST,

  GETAYURVEDICOPDCOMPLAINTOBSTETRICALHIST,
  CREATEAYURVVEDICOPDCOMPLAINTOBSTETRICALHIST,
  UPDATEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST,
  DELETEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST,

  GETAYURVEDICOPDEXAMGENERALLOOKHIST,
  CREATEAYURVVEDICOPDEXAMGENERALLOOKHIST,
  UPDATEAYURVEDICOPDEXAMGENERALLOOKHIST,
  DELETEAYURVEDICOPDEXAMGENERALLOOKHIST,
  GETAYURVEDICOPDEXAMGENERALBUILD,
  CREATEAYURVVEDICOPDEXAMGENERALBUILD,
  UPDATEAYURVEDICOPDEXAMGENERALBUILD,
  DELETEAYURVEDICOPDEXAMGENERALBUILD,
  GETAYURVEDICOPDEXAMGENERALNUTRITION,
  CREATEAYURVVEDICOPDEXAMGENERALNUTRITION,
  UPDATEAYURVEDICOPDEXAMGENERALNUTRITION,
  DELETEAYURVEDICOPDEXAMGENERALNUTRITION,
  GETAYURVEDICOPDEXAMGENERALANAEMIA,
  CREATEAYURVVEDICOPDEXAMGENERALANAEMIA,
  UPDATEAYURVEDICOPDEXAMGENERALANAEMIA,
  DELETEAYURVEDICOPDEXAMGENERALANAEMIA,
  GETAYURVEDICOPDEXAMGENERALNECKVEIN,
  CREATEAYURVVEDICOPDEXAMGENERALNECKVEIN,
  UPDATEAYURVEDICOPDEXAMGENERALNECKVEIN,
  DELETEAYURVEDICOPDEXAMGENERALNECKVEIN,
  GETAYURVEDICOPDEXAMGENERALLYMPHNODE,
  CREATEAYURVVEDICOPDEXAMGENERALLYMPHNODE,
  UPDATEAYURVEDICOPDEXAMGENERALLYMPHNODE,
  DELETEAYURVEDICOPDEXAMGENERALLYMPHNODE,
  GETAYURVEDICOPDEXAMGENERALOTHERFIELDS,
  CREATEAYURVVEDICOPDEXAMGENERALOTHERFIELDS,
  UPDATEAYURVEDICOPDEXAMGENERALOTHERFIELDS,
  DELETEAYURVEDICOPDEXAMGENERALOTHERFIELDS,
  GETAYURVEDICOPDEXAMASHTAVIDAPULSE,
  CREATEAYURVVEDICOPDEXAMASHTAVIDAPULSE,
  UPDATEAYURVEDICOPDEXAMASHTAVIDAPULSE,
  DELETEAYURVEDICOPDEXAMASHTAVIDAPULSE,
  GETAYURVEDICOPDEXAMASHTAVIDATONGUE,
  CREATEAYURVVEDICOPDEXAMASHTAVIDATONGUE,
  UPDATEAYURVEDICOPDEXAMASHTAVIDATONGUE,
  DELETEAYURVEDICOPDEXAMASHTAVIDATONGUE,
  GETAYURVEDICOPDEXAMASHTAVIDAPOOP,
  CREATEAYURVVEDICOPDEXAMASHTAVIDAPOOP,
  UPDATEAYURVEDICOPDEXAMASHTAVIDAPOOP,
  DELETEAYURVEDICOPDEXAMASHTAVIDAPOOP,
  GETAYURVEDICOPDEXAMASHTAVIDAURINE,
  CREATEAYURVVEDICOPDEXAMASHTAVIDAURINE,
  UPDATEAYURVEDICOPDEXAMASHTAVIDAURINE,
  DELETEAYURVEDICOPDEXAMASHTAVIDAURINE,
  GETAYURVEDICOPDEXAMASHTAVIDAWORD,
  CREATEAYURVVEDICOPDEXAMASHTAVIDAWORD,
  UPDATEAYURVEDICOPDEXAMASHTAVIDAWORD,
  DELETEAYURVEDICOPDEXAMASHTAVIDAWORD,
  GETAYURVEDICOPDEXAMASHTAVIDATOUCH,
  CREATEAYURVVEDICOPDEXAMASHTAVIDATOUCH,
  UPDATEAYURVEDICOPDEXAMASHTAVIDATOUCH,
  DELETEAYURVEDICOPDEXAMASHTAVIDATOUCH,
  GETAYURVEDICOPDEXAMASHTAVIDAEYE,
  CREATEAYURVVEDICOPDEXAMASHTAVIDAEYE,
  UPDATEAYURVEDICOPDEXAMASHTAVIDAEYE,
  DELETEAYURVEDICOPDEXAMASHTAVIDAEYE,
  GETAYURVEDICOPDEXAMASHTAVIDAAKRITA,
  CREATEAYURVVEDICOPDEXAMASHTAVIDAAKRITA,
  UPDATEAYURVEDICOPDEXAMASHTAVIDAAKRITA,
  DELETEAYURVEDICOPDEXAMASHTAVIDAAKRITA,
  GETAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA,
  CREATEAYURVVEDICOPDEXAMASHTAVIDAOTHHERFILEDA,
  UPDATEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA,
  DELETEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA,
  GETAYURVEDICOPDEXAMDASHVIDAPHYSICAL,
  CREATEAYURVVEDICOPDEXAMDASHVIDAPHYSICAL,
  UPDATEAYURVEDICOPDEXAMDASHVIDAPHYSICAL,
  DELETEAYURVEDICOPDEXAMDASHVIDAPHYSICAL,
  GETAYURVEDICOPDEXAMDASHVIDAMENTAL,
  CREATEAYURVVEDICOPDEXAMDASHVIDAMENTAL,
  UPDATEAYURVEDICOPDEXAMDASHVIDAMENTAL,
  DELETEAYURVEDICOPDEXAMDASHVIDAMENTAL,
  GETAYURVEDICOPDEXAMDASHVIDASUBSTANCE,
  CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCE,
  UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCE,
  DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCE,
  GETAYURVEDICOPDEXAMDASHVIDACOMPACTION,
  CREATEAYURVVEDICOPDEXAMDASHVIDACOMPACTION,
  UPDATEAYURVEDICOPDEXAMDASHVIDACOMPACTION,
  DELETEAYURVEDICOPDEXAMDASHVIDACOMPACTION,
  GETAYURVEDICOPDEXAMDASHVIDAPERCEPTION,
  CREATEAYURVVEDICOPDEXAMDASHVIDAPERCEPTION,
  UPDATEAYURVEDICOPDEXAMDASHVIDAPERCEPTION,
  DELETEAYURVEDICOPDEXAMDASHVIDAPERCEPTION,
  GETAYURVEDICOPDEXAMDASHVIDASUITABILITY,
  CREATEAYURVVEDICOPDEXAMDASHVIDASUITABILITY,
  UPDATEAYURVEDICOPDEXAMDASHVIDASUITABILITY,
  DELETEAYURVEDICOPDEXAMDASHVIDASUITABILITY,
  GETAYURVEDICOPDEXAMDASHVIDASUBSTANCEE,
  CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCEE,
  UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE,
  DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE,
  GETAYURVEDICOPDEXAMDASHVIDADIETCARRY,
  CREATEAYURVVEDICOPDEXAMDASHVIDADIETCARRY,
  UPDATEAYURVEDICOPDEXAMDASHVIDADIETCARRY,
  DELETEAYURVEDICOPDEXAMDASHVIDADIETCARRY,
  GETAYURVEDICOPDEXAMDASHVIDADIETBURNING,
  CREATEAYURVVEDICOPDEXAMDASHVIDADIETBURNING,
  UPDATEAYURVEDICOPDEXAMDASHVIDADIETBURNING,
  DELETEAYURVEDICOPDEXAMDASHVIDADIETBURNING,
  GETAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER,
  CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEPOWER,
  UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER,
  DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER,
  GETAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE,
  CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEAGEE,
  UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE,
  DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE,
  GETAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS,
  CREATEAYURVVEDICOPDEXAMDASHVIDAOTHERFIELDS,
  UPDATEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS,
  DELETEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS,
  GETAYURVEDICOPDEXAMSROTASPRANAVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASPRANAVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASPRANAVAHA,
  DELETEAYURVEDICOPDEXAMSROTASPRANAVAHA,
  GETAYURVEDICOPDEXAMSROTASANNAVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASANNAVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASANNAVAHA,
  DELETEAYURVEDICOPDEXAMSROTASANNAVAHA,
  GETAYURVEDICOPDEXAMSROTASUDAKVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASUDAKVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASUDAKVAHA,
  DELETEAYURVEDICOPDEXAMSROTASUDAKVAHA,
  GETAYURVEDICOPDEXAMSROTASRASAVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASRASAVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASRASAVAHA,
  DELETEAYURVEDICOPDEXAMSROTASRASAVAHA,
  GETAYURVEDICOPDEXAMSROTASRAKTAVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASRAKTAVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASRAKTAVAHA,
  DELETEAYURVEDICOPDEXAMSROTASRAKTAVAHA,
  GETAYURVEDICOPDEXAMSROTASMAMSAVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASMAMSAVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASMAMSAVAHA,
  DELETEAYURVEDICOPDEXAMSROTASMAMSAVAHA,
  GETAYURVEDICOPDEXAMSROTASMEDOVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASMEDOVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASMEDOVAHA,
  DELETEAYURVEDICOPDEXAMSROTASMEDOVAHA,
  GETAYURVEDICOPDEXAMSROTASASTHIVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASASTHIVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASASTHIVAHA,
  DELETEAYURVEDICOPDEXAMSROTASASTHIVAHA,
  GETAYURVEDICOPDEXAMSROTASMAJJAVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASMAJJAVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASMAJJAVAHA,
  DELETEAYURVEDICOPDEXAMSROTASMAJJAVAHA,
  GETAYURVEDICOPDEXAMSROTASSUKRAVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASSUKRAVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASSUKRAVAHA,
  DELETEAYURVEDICOPDEXAMSROTASSUKRAVAHA,
  GETAYURVEDICOPDEXAMSROTASMOOTRAVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASMOOTRAVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASMOOTRAVAHA,
  DELETEAYURVEDICOPDEXAMSROTASMOOTRAVAHA,
  GETAYURVEDICOPDEXAMSROTASPURESHVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASPURESHVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASPURESHVAHA,
  DELETEAYURVEDICOPDEXAMSROTASPURESHVAHA,
  GETAYURVEDICOPDEXAMVIKRUTHIFIELDS,
  CREATEAYURVVEDICOPDEXAMVIKRUTHIFIELDS,
  UPDATEAYURVEDICOPDEXAMVIKRUTHIFIELDS,
  DELETEAYURVEDICOPDEXAMVIKRUTHIFIELDS,
  GETAYURVEDICOPDEXAMWEALTHFAULT,
  CREATEAYURVVEDICOPDEXAMWEALTHFAULT,
  UPDATEAYURVEDICOPDEXAMWEALTHFAULT,
  DELETEAYURVEDICOPDEXAMWEALTHFAULT,
  GETAYURVEDICOPDEXAMWEALTHDUSHYA,
  CREATEAYURVVEDICOPDEXAMWEALTHDUSHYA,
  UPDATEAYURVEDICOPDEXAMWEALTHDUSHYA,
  DELETEAYURVEDICOPDEXAMWEALTHDUSHYA,
  GETAYURVEDICOPDEXAMWEALTHFIRE,
  CREATEAYURVVEDICOPDEXAMWEALTHFIRE,
  UPDATEAYURVEDICOPDEXAMWEALTHFIRE,
  DELETEAYURVEDICOPDEXAMWEALTHFIRE,
  GETAYURVEDICOPDEXAMWEALTHAMA,
  CREATEAYURVVEDICOPDEXAMWEALTHAMA,
  UPDATEAYURVEDICOPDEXAMWEALTHAMA,
  DELETEAYURVEDICOPDEXAMWEALTHAMA,
  GETAYURVEDICOPDEXAMWEALTHSOURCES,
  CREATEAYURVVEDICOPDEXAMWEALTHSOURCES,
  UPDATEAYURVEDICOPDEXAMWEALTHSOURCES,
  DELETEAYURVEDICOPDEXAMWEALTHSOURCES,
  GETAYURVEDICOPDEXAMWEALTHFAULTYSOURCES,
  CREATEAYURVVEDICOPDEXAMWEALTHFAULTYSOURCES,
  UPDATEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES,
  DELETEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES,
  GETAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN,
  CREATEAYURVVEDICOPDEXAMWEALTHPLACEOFORIGIN,
  UPDATEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN,
  DELETEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN,
  GETAYURVEDICOPDEXAMWEALTHFACTOR,
  CREATEAYURVVEDICOPDEXAMWEALTHFACTOR,
  UPDATEAYURVEDICOPDEXAMWEALTHFACTOR,
  DELETEAYURVEDICOPDEXAMWEALTHFACTOR,
  GETAYURVEDICOPDEXAMSROTASSWEDAVAHA,
  CREATEAYURVVEDICOPDEXAMSROTASSWEDAVAHA,
  UPDATEAYURVEDICOPDEXAMSROTASSWEDAVAHA,
  DELETEAYURVEDICOPDEXAMSROTASSWEDAVAHA,
  GETAYURVEDICOPDPANCHAKRMA,
CREATEAYURVVEDICOPDPANCHAKRMA,
UPDATEAYURVEDICOPDPANCHAKRMA,
DELETEAYURVEDICOPDPANCHAKRMA,
} from "../actions/types"

const initialState = {

};

export default function setupayurvedicopdReducer(state = initialState, action) {
  switch (action.type) {
    case CREATEAYURVVEDICOPDPAINASSESSMENT:
      return {
        ...state,
        ayurvedicopdpainassesmentSaveStatus: action.payload.success,
      }
    case GETAYURVEDICOPDPAINASSESSMENT:
      return {
        ...state,
        ayurvedicopdpainassesmentList: action.payload.data,
      }
    case UPDATEAYURVEDICOPDPAINASSESSMENT:
      return {
        ...state,
        ayurvedicopdpainassesmentUpdateStatus: action.payload.success,
      }

    case DELETEAYURVEDICOPDPAINASSESSMENT:
      return {
        ...state,
        ayurvedicopdpainassesmentDeleteStatus: action.payload.success,
      }


    case GETSETUPAYURVEDICOPDBODYCHART:
      return {
        ...state,
        ayurvedicopdBodyChartList: action.payload.data,
      }
    case CREATESETUPAYURVEDICOPDBODYCHART:
      return {
        ...state,
        ayurvedicopdBodyChartSaveStatus: action.payload.success,
      }
    case UPDATESETUPAYURVEDICOPDBODYCHART:
      return {
        ...state,
        ayurvedicopdBodyChartUpdateStatus: action.payload.success,
      }

    case DELETESETUPAYURVEDICOPDBODYCHART:
      return {
        ...state,
        ayurvedicopdBodyChartDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCHIEFSYMTOMPS:
      return {
        ...state,
        ayurvedicopdChiefSymtompList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCHIEFSYMTOMPS:
      return {
        ...state,
        ayurvedicopdChiefSymtompSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCHIEFSYMTOMPS:
      return {
        ...state,
        ayurvedicopdChiefSymtompUpdateStatus: action.payload.success,
      }

    case DELETEAYURVEDICOPDCHIEFSYMTOMPS:
      return {
        ...state,
        ayurvedicopdChiefSymtompDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDASSOCIATEDSYMTOMPS:
      return {
        ...state,
        ayurvedicopdAssociatedSymtompList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDASSOCIATEDSYMTOMPS:
      return {
        ...state,
        ayurvedicopdAssociatedSymtompSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDASSOCIATEDSYMTOMPS:
      return {
        ...state,
        ayurvedicopdAssociatedSymtompUpdateStatus: action.payload.success,
      }

    case DELETEAYURVEDICOPDASSOCIATEDSYMTOMPS:
      return {
        ...state,
        ayurvedicopdAssociatedSymtompDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDPRESENTILLCOMORBIDITY:
      return {
        ...state,
        ayurvedicopdPresentillSymtompList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDPRESENTILLCOMORBIDITY:
      return {
        ...state,
        ayurvedicopdPresentillSymtompSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDPRESENTILLCOMORBIDITY:
      return {
        ...state,
        ayurvedicopdPresentillSymtompUpdateStatus: action.payload.success,
      }

    case DELETEAYURVEDICOPDPRESENTILLCOMORBIDITY:
      return {
        ...state,
        ayurvedicopdPresentillSymtompDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDFAMILYSYMTOMPS:
      return {
        ...state,
        ayurvedicopdFamilySymtompList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDFAMILYSYMTOMPS:
      return {
        ...state,
        ayurvedicopdFamilySymtompSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDFAMILYSYMTOMPS:
      return {
        ...state,
        ayurvedicopdFamilySymtompUpdateStatus: action.payload.success,
      }

    case DELETEAYURVEDICOPDFAMILYSYMTOMPS:
      return {
        ...state,
        ayurvedicopdFamilySymtompDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDFAMILYCOMORBIDITY:
      return {
        ...state,
        ayurvedicopdFamilyComorbidityList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDFAMILYCOMORBIDITY:
      return {
        ...state,
        ayurvedicopdFamilyComorbiditySaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDFAMILYCOMORBIDITY:
      return {
        ...state,
        ayurvedicopdFamilyComorbidityUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDFAMILYCOMORBIDITY:
      return {
        ...state,
        ayurvedicopdFamilyComorbidityDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDPRESENTCOMORILLNESS:
      return {
        ...state,
        ayurvedicopdPresentillnessComorbidityList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDPRESENTCOMORILLNESS:
      return {
        ...state,
        ayurvedicopdPresentillnessComorbiditySaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDPRESENTCOMORILLNESS:
      return {
        ...state,
        ayurvedicopdPresentillnessComorbidityUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDPRESENTCOMORILLNESS:
      return {
        ...state,
        ayurvedicopdPresentillnessComorbidityDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDPASTILLNESS:
      return {
        ...state,
        ayurvedicopdPastillnessComorbidityList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDPASTILLNESS:
      return {
        ...state,
        ayurvedicopdPastComorbiditySaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDPASTILLNESS:
      return {
        ...state,
        ayurvedicopdPastComorbidityUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDPASTILLNESS:
      return {
        ...state,
        ayurvedicopdPastComorbidityDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDFAMILYILLNESS:
      return {
        ...state,
        ayurvedicopdFamilyillnessComorbidityList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDFAMILYILLNESS:
      return {
        ...state,
        ayurvedicopdFamilyComorbiditySaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDFAMILYILLNESS:
      return {
        ...state,
        ayurvedicopdFamilyComorbidityUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDFAMILYILLNESS:
      return {
        ...state,
        ayurvedicopdFamilyComorbidityDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTAPPETITE:
      return {
        ...state,
        ayurvedicopdComplaintappetiteList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTAPPETITE:
      return {
        ...state,
        ayurvedicopdComplaintappetiteSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTAPPETITE:
      return {
        ...state,
        ayurvedicopdComplaintappetiteUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTAPPETITE:
      return {
        ...state,
        ayurvedicopdComplaintappetiteDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTDIGESTIVETRACT:
      return {
        ...state,
        ayurvedicopdComplaintDigestiveTractList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTDIGESTIVETRACT:
      return {
        ...state,
        ayurvedicopdComplaintDigestiveTractSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT:
      return {
        ...state,
        ayurvedicopdComplaintDigestiveTractUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT:
      return {
        ...state,
        ayurvedicopdComplaintDigestiveTractDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTBOWEL:
      return {
        ...state,
        ayurvedicopdComplaintBowelList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTBOWEL:
      return {
        ...state,
        ayurvedicopdComplaintBowelSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTBOWEL:
      return {
        ...state,
        ayurvedicopdComplaintBowelUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTBOWEL:
      return {
        ...state,
        ayurvedicopdComplaintBowelDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTSLEEP:
      return {
        ...state,
        ayurvedicopdComplaintSleepList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTSLEEP:
      return {
        ...state,
        ayurvedicopdComplaintSleepSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTSLEEP:
      return {
        ...state,
        ayurvedicopdComplaintSleepUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTSLEEP:
      return {
        ...state,
        ayurvedicopdComplaintSleepDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTADDICTIONS:
      return {
        ...state,
        ayurvedicopdComplaintAddictionList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTADDICTIONS:
      return {
        ...state,
        ayurvedicopdComplaintAddictionSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTADDICTIONS:
      return {
        ...state,
        ayurvedicopdComplaintAddictionUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTADDICTIONS:
      return {
        ...state,
        ayurvedicopdComplaintAddictionDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTHIGHRISK:
      return {
        ...state,
        ayurvedicopdComplaintHighRiskList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTHIGHRISK:
      return {
        ...state,
        ayurvedicopdComplaintHighRiskSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTHIGHRISK:
      return {
        ...state,
        ayurvedicopdComplaintHighRiskUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTHIGHRISK:
      return {
        ...state,
        ayurvedicopdComplaintHighRiskDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTPOSITIONOFWORK:
      return {
        ...state,
        ayurvedicopdComplaintPositionOfWorkList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTPOSITIONOFWORK:
      return {
        ...state,
        ayurvedicopdComplaintPositionOfWorkSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK:
      return {
        ...state,
        ayurvedicopdComplaintPositionOfWorkUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK:
      return {
        ...state,
        ayurvedicopdComplaintPositionOfWorkDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTNATUREOFWORK:
      return {
        ...state,
        ayurvedicopdComplaintNatureOfWorkList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTNATUREOFWORK:
      return {
        ...state,
        ayurvedicopdComplaintNatureOfWorkSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTNATUREOFWORK:
      return {
        ...state,
        ayurvedicopdComplaintNatureOfWorkUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTNATUREOFWORK:
      return {
        ...state,
        ayurvedicopdComplaintNatureOfWorkDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTALLOPATHICMEDI:
      return {
        ...state,
        ayurvedicopdComplaintAllopathyMediList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTALLOPATHICMEDI:
      return {
        ...state,
        ayurvedicopdComplaintAllopathyMediSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI:
      return {
        ...state,
        ayurvedicopdComplaintAllopathyMediUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI:
      return {
        ...state,
        ayurvedicopdComplaintAllopathyMediDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTAYURVDAMEDI:
      return {
        ...state,
        ayurvedicopdComplaintAyurvedaMediList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTAYURVDAMEDI:
      return {
        ...state,
        ayurvedicopdComplaintAyurvedaMediSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTAYURVDAMEDI:
      return {
        ...state,
        ayurvedicopdComplaintAyurvedaMediUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTAYURVDAMEDI:
      return {
        ...state,
        ayurvedicopdComplaintAyurvedaMediDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI:
      return {
        ...state,
        ayurvedicopdComplaintHomeopathyMediList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTHOMEOATHYMEDI:
      return {
        ...state,
        ayurvedicopdComplaintHomeopathyMediSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI:
      return {
        ...state,
        ayurvedicopdComplaintHomeopathyMediUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI:
      return {
        ...state,
        ayurvedicopdComplaintHomeopathyMediDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTOTHERMEDI:
      return {
        ...state,
        ayurvedicopdComplaintOtherMediList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTOTHERMEDI:
      return {
        ...state,
        ayurvedicopdComplaintOtherMediSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTOTHERMEDI:
      return {
        ...state,
        ayurvedicopdComplaintOtherMediUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTOTHERMEDI:
      return {
        ...state,
        ayurvedicopdComplaintOtherMediDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTANXIETY:
      return {
        ...state,
        ayurvedicopdComplaintAnxietyList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTANXIETY:
      return {
        ...state,
        ayurvedicopdComplaintAnxietySaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTANXIETY:
      return {
        ...state,
        ayurvedicopdComplaintAnxietyUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTANXIETY:
      return {
        ...state,
        ayurvedicopdComplaintAnxietyDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTDEPRESSION:
      return {
        ...state,
        ayurvedicopdComplaintDepressionList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTDEPRESSION:
      return {
        ...state,
        ayurvedicopdComplaintDepressionSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTDEPRESSION:
      return {
        ...state,
        ayurvedicopdComplaintDepressionUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTDEPRESSION:
      return {
        ...state,
        ayurvedicopdComplaintDepressionDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTIRRITABIILTY:
      return {
        ...state,
        ayurvedicopdComplaintIrritabilityList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTIRRITABIILTY:
      return {
        ...state,
        ayurvedicopdComplaintIrritabilitySaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTIRRITABIILTY:
      return {
        ...state,
        ayurvedicopdComplaintIrritabilityUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTIRRITABIILTY:
      return {
        ...state,
        ayurvedicopdComplaintIrritabilityDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTEUPHORIA:
      return {
        ...state,
        ayurvedicopdComplaintEuphoriaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTEUPHORIA:
      return {
        ...state,
        ayurvedicopdComplaintEuphoriaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTEUPHORIA:
      return {
        ...state,
        ayurvedicopdComplaintEuphoriaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTEUPHORIA:
      return {
        ...state,
        ayurvedicopdComplaintEuphoriaDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTOBSESSION:
      return {
        ...state,
        ayurvedicopdComplaintObsessionList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTOBSESSION:
      return {
        ...state,
        ayurvedicopdComplaintObsessionSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTOBSESSION:
      return {
        ...state,
        ayurvedicopdComplaintObsessionUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTOBSESSION:
      return {
        ...state,
        ayurvedicopdComplaintObsessionDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTNEUROSIS:
      return {
        ...state,
        ayurvedicopdComplaintNeurosisList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTNEUROSIS:
      return {
        ...state,
        ayurvedicopdComplaintNeurosisSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTNEUROSIS:
      return {
        ...state,
        ayurvedicopdComplaintNeurosisUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTNEUROSIS:
      return {
        ...state,
        ayurvedicopdComplaintNeurosisDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTDEPERSONALIZATION:
      return {
        ...state,
        ayurvedicopdComplaintDepersonalizationList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTDEPERSONALIZATION:
      return {
        ...state,
        ayurvedicopdComplaintDepersonalizationSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION:
      return {
        ...state,
        ayurvedicopdComplaintDepersonalizationUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION:
      return {
        ...state,
        ayurvedicopdComplaintDepersonalizationDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE:
      return {
        ...state,
        ayurvedicopdComplaintMenstrualCycleList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTMENSTRUALCYCLE:
      return {
        ...state,
        ayurvedicopdComplaintMenstrualCycleSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE:
      return {
        ...state,
        ayurvedicopdComplaintMenstrualCycleUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE:
      return {
        ...state,
        ayurvedicopdComplaintMenstrualCycleDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY:
      return {
        ...state,
        ayurvedicopdComplaintNatureOfDeliveryList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTNATUREOFDELIVERY:
      return {
        ...state,
        ayurvedicopdComplaintNatureOfDeliverySaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY:
      return {
        ...state,
        ayurvedicopdComplaintNatureOfDeliveryUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY:
      return {
        ...state,
        ayurvedicopdComplaintNatureOfDeliveryDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST:
      return {
        ...state,
        ayurvedicopdComplaintOccupationalHistList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTOCCUPATIONALHIST:
      return {
        ...state,
        ayurvedicopdComplaintOccupationalHistSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST:
      return {
        ...state,
        ayurvedicopdComplaintOccupationalHistUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST:
      return {
        ...state,
        ayurvedicopdComplaintOccupationalHistDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST:
      return {
        ...state,
        ayurvedicopdComplaintGynecologicHistList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTGYNECOLOGICHIST:
      return {
        ...state,
        ayurvedicopdComplaintGynecologicHistSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST:
      return {
        ...state,
        ayurvedicopdComplaintGynecologicHistUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST:
      return {
        ...state,
        ayurvedicopdComplaintGynecologicHistDeleteStatus: action.payload.success,
      }

    case GETAYURVEDICOPDCOMPLAINTOBSTETRICALHIST:
      return {
        ...state,
        ayurvedicopdComplaintObstetricalHistList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDCOMPLAINTOBSTETRICALHIST:
      return {
        ...state,
        ayurvedicopdComplaintObstetricalHistSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST:
      return {
        ...state,
        ayurvedicopdComplaintObstetricalHistUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST:
      return {
        ...state,
        ayurvedicopdComplaintObstetricalHistDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMGENERALLOOKHIST:
      return {
        ...state,
        ayurvedicopdExamGeneralLookList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMGENERALLOOKHIST:
      return {
        ...state,
        ayurvedicopdExamGeneralLookSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMGENERALLOOKHIST:
      return {
        ...state,
        ayurvedicopdExamGeneralLookUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMGENERALLOOKHIST:
      return {
        ...state,
        ayurvedicopdExamGeneralLookDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMGENERALBUILD:
      return {
        ...state,
        ayurvedicopdExamGeneralBuildList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMGENERALBUILD:
      return {
        ...state,
        ayurvedicopdExamGeneralBuildSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMGENERALBUILD:
      return {
        ...state,
        ayurvedicopdExamGeneralBuildUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMGENERALBUILD:
      return {
        ...state,
        ayurvedicopdExamGeneralBuildDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMGENERALNUTRITION:
      return {
        ...state,
        ayurvedicopdExamGeneralNutritionList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMGENERALNUTRITION:
      return {
        ...state,
        ayurvedicopdExamGeneralNutritionSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMGENERALNUTRITION:
      return {
        ...state,
        ayurvedicopdExamGeneralNutritionUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMGENERALNUTRITION:
      return {
        ...state,
        ayurvedicopdExamGeneralNutritionDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMGENERALANAEMIA:
      return {
        ...state,
        ayurvedicopdExamGeneralAnaemiaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMGENERALANAEMIA:
      return {
        ...state,
        ayurvedicopdExamGeneralAnaemiaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMGENERALANAEMIA:
      return {
        ...state,
        ayurvedicopdExamGeneralAnaemiaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMGENERALANAEMIA:
      return {
        ...state,
        ayurvedicopdExamGeneralAnaemiaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMGENERALNECKVEIN:
      return {
        ...state,
        ayurvedicopdExamGeneralNeckVeinList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMGENERALNECKVEIN:
      return {
        ...state,
        ayurvedicopdExamGeneralNeckVeinSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMGENERALNECKVEIN:
      return {
        ...state,
        ayurvedicopdExamGeneralNeckVeinUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMGENERALNECKVEIN:
      return {
        ...state,
        ayurvedicopdExamGeneralNeckVeinDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMGENERALLYMPHNODE:
      return {
        ...state,
        ayurvedicopdExamGeneralLymphnodeList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMGENERALLYMPHNODE:
      return {
        ...state,
        ayurvedicopdExamGeneralLymphnodeSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMGENERALLYMPHNODE:
      return {
        ...state,
        ayurvedicopdExamGeneralLymphnodeUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMGENERALLYMPHNODE:
      return {
        ...state,
        ayurvedicopdExamGeneralLymphnodeDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMGENERALOTHERFIELDS:
      return {
        ...state,
        ayurvedicopdExamGeneralOtherfieldsList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMGENERALOTHERFIELDS:
      return {
        ...state,
        ayurvedicopdExamGeneralOtherfieldsSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMGENERALOTHERFIELDS:
      return {
        ...state,
        ayurvedicopdExamGeneralOtherfieldsUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMGENERALOTHERFIELDS:
      return {
        ...state,
        ayurvedicopdExamGeneralOtherfieldsDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMASHTAVIDAPULSE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaPulseList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMASHTAVIDAPULSE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaPulseSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMASHTAVIDAPULSE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaPulseUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMASHTAVIDAPULSE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaPulseDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMASHTAVIDATONGUE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaTongueList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMASHTAVIDATONGUE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaTongueSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMASHTAVIDATONGUE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaTongueUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMASHTAVIDATONGUE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaTongueDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMASHTAVIDAPOOP:
      return {
        ...state,
        ayurvedicopdExamAshtavidaPoopList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMASHTAVIDAPOOP:
      return {
        ...state,
        ayurvedicopdExamAshtavidaPoopSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMASHTAVIDAPOOP:
      return {
        ...state,
        ayurvedicopdExamAshtavidaPoopUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMASHTAVIDAPOOP:
      return {
        ...state,
        ayurvedicopdExamAshtavidaPoopDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMASHTAVIDAURINE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaUrineList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMASHTAVIDAURINE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaUrineSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMASHTAVIDAURINE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaUrineUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMASHTAVIDAURINE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaUrineDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMASHTAVIDAWORD:
      return {
        ...state,
        ayurvedicopdExamAshtavidaWordList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMASHTAVIDAWORD:
      return {
        ...state,
        ayurvedicopdExamAshtavidaWordSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMASHTAVIDAWORD:
      return {
        ...state,
        ayurvedicopdExamAshtavidaWordUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMASHTAVIDAWORD:
      return {
        ...state,
        ayurvedicopdExamAshtavidaWordDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMASHTAVIDATOUCH:
      return {
        ...state,
        ayurvedicopdExamAshtavidaTouchList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMASHTAVIDATOUCH:
      return {
        ...state,
        ayurvedicopdExamAshtavidaTouchSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMASHTAVIDATOUCH:
      return {
        ...state,
        ayurvedicopdExamAshtavidaTouchUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMASHTAVIDATOUCH:
      return {
        ...state,
        ayurvedicopdExamAshtavidaTouchDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMASHTAVIDAEYE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaEyeList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMASHTAVIDAEYE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaEyeSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMASHTAVIDAEYE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaEyeUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMASHTAVIDAEYE:
      return {
        ...state,
        ayurvedicopdExamAshtavidaEyeDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMASHTAVIDAAKRITA:
      return {
        ...state,
        ayurvedicopdExamAshtavidaAkritaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMASHTAVIDAAKRITA:
      return {
        ...state,
        ayurvedicopdExamAshtavidaAkritaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMASHTAVIDAAKRITA:
      return {
        ...state,
        ayurvedicopdExamAshtavidaAkritaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMASHTAVIDAAKRITA:
      return {
        ...state,
        ayurvedicopdExamAshtavidaAkritaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA:
      return {
        ...state,
        ayurvedicopdExamAshtavidaOtherfieldsList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMASHTAVIDAOTHHERFILEDA:
      return {
        ...state,
        ayurvedicopdExamAshtavidaOtherfieldsSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA:
      return {
        ...state,
        ayurvedicopdExamAshtavidaOtherfieldsUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA:
      return {
        ...state,
        ayurvedicopdExamAshtavidaOtherfieldsDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDAPHYSICAL:
      return {
        ...state,
        ayurvedicopdExamDashvidaPhysicalList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDAPHYSICAL:
      return {
        ...state,
        ayurvedicopdExamDashvidaPhysicalSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDAPHYSICAL:
      return {
        ...state,
        ayurvedicopdExamDashvidaPhysicalUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDAPHYSICAL:
      return {
        ...state,
        ayurvedicopdExamDashvidaPhysicalDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDAMENTAL:
      return {
        ...state,
        ayurvedicopdExamDashvidaMentalList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDAMENTAL:
      return {
        ...state,
        ayurvedicopdExamDashvidaMentalSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDAMENTAL:
      return {
        ...state,
        ayurvedicopdExamDashvidaMentalUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDAMENTAL:
      return {
        ...state,
        ayurvedicopdExamDashvidaMentalDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDASUBSTANCE:
      return {
        ...state,
        ayurvedicopdExamDashvidaSubstanceList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCE:
      return {
        ...state,
        ayurvedicopdExamDashvidaSubstanceSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCE:
      return {
        ...state,
        ayurvedicopdExamDashvidaSubstanceUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCE:
      return {
        ...state,
        ayurvedicopdExamDashvidaSubstanceDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDACOMPACTION:
      return {
        ...state,
        ayurvedicopdExamDashvidaCompactionList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDACOMPACTION:
      return {
        ...state,
        ayurvedicopdExamDashvidaCompactionSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDACOMPACTION:
      return {
        ...state,
        ayurvedicopdExamDashvidaCompactionUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDACOMPACTION:
      return {
        ...state,
        ayurvedicopdExamDashvidaCompactionDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDAPERCEPTION:
      return {
        ...state,
        ayurvedicopdExamDashvidaPerceptionList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDAPERCEPTION:
      return {
        ...state,
        ayurvedicopdExamDashvidaPerceptionSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDAPERCEPTION:
      return {
        ...state,
        ayurvedicopdExamDashvidaPerceptionUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDAPERCEPTION:
      return {
        ...state,
        ayurvedicopdExamDashvidaPerceptionDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDASUITABILITY:
      return {
        ...state,
        ayurvedicopdExamDashvidaSuitabilityList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDASUITABILITY:
      return {
        ...state,
        ayurvedicopdExamDashvidaSuitabilitySaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDASUITABILITY:
      return {
        ...state,
        ayurvedicopdExamDashvidaSuitabilityUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDASUITABILITY:
      return {
        ...state,
        ayurvedicopdExamDashvidaSuitabilityDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDASUBSTANCEE:
      return {
        ...state,
        ayurvedicopdExamDashvidaSubstanceeList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCEE:
      return {
        ...state,
        ayurvedicopdExamDashvidaSubstanceeSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE:
      return {
        ...state,
        ayurvedicopdExamDashvidaSubstanceeUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE:
      return {
        ...state,
        ayurvedicopdExamDashvidaSubstanceeDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDADIETCARRY:
      return {
        ...state,
        ayurvedicopdExamDashvidaDietCarryList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDADIETCARRY:
      return {
        ...state,
        ayurvedicopdExamDashvidaDietCarrySaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDADIETCARRY:
      return {
        ...state,
        ayurvedicopdExamDashvidaDietCarryUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDADIETCARRY:
      return {
        ...state,
        ayurvedicopdExamDashvidaDietCarryDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDADIETBURNING:
      return {
        ...state,
        ayurvedicopdExamDashvidaDietburningList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDADIETBURNING:
      return {
        ...state,
        ayurvedicopdExamDashvidaDietburningSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDADIETBURNING:
      return {
        ...state,
        ayurvedicopdExamDashvidaDietburningUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDADIETBURNING:
      return {
        ...state,
        ayurvedicopdExamDashvidaDietburningDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER:
      return {
        ...state,
        ayurvedicopdExamDashvidaExercisePowerList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEPOWER:
      return {
        ...state,
        ayurvedicopdExamDashvidaExercisePowerSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER:
      return {
        ...state,
        ayurvedicopdExamDashvidaExercisePowerUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER:
      return {
        ...state,
        ayurvedicopdExamDashvidaExercisePowerDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE:
      return {
        ...state,
        ayurvedicopdExamDashvidaExerciseAgeeList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEAGEE:
      return {
        ...state,
        ayurvedicopdExamDashvidaExerciseAgeeSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE:
      return {
        ...state,
        ayurvedicopdExamDashvidaExerciseAgeeUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE:
      return {
        ...state,
        ayurvedicopdExamDashvidaExerciseAgeeDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS:
      return {
        ...state,
        ayurvedicopdExamDashvidaOtherFieldsList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMDASHVIDAOTHERFIELDS:
      return {
        ...state,
        ayurvedicopdExamDashvidaOtherFieldsSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS:
      return {
        ...state,
        ayurvedicopdExamDashvidaOtherFieldsUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS:
      return {
        ...state,
        ayurvedicopdExamDashvidaOtherFieldsDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASPRANAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasPranavahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASPRANAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasPranavahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASPRANAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasPranavahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASPRANAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasPranavahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASANNAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasAnnavahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASANNAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasAnnavahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASANNAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasAnnavahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASANNAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasAnnavahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASUDAKVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasUdakvahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASUDAKVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasUdakvahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASUDAKVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasUdakvahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASUDAKVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasUdakvahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASRASAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasRassavahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASRASAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasRassavahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASRASAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasRassavahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASRASAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasRassavahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASRAKTAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasRaktavahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASRAKTAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasRaktavahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASRAKTAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasRaktavahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASRAKTAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasRaktavahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASMAMSAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMamsavahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASMAMSAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMamsavahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASMAMSAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMamsavahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASMAMSAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMamsavahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASMEDOVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMedovahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASMEDOVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMedovahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASMEDOVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMedovahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASMEDOVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMedovahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASASTHIVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasAsthivahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASASTHIVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasAsthivahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASASTHIVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasAsthivahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASASTHIVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasAsthivahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASMAJJAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMajjavahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASMAJJAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMajjavahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASMAJJAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMajjavahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASMAJJAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMajjavahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASSUKRAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasSukravahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASSUKRAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasSukravahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASSUKRAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasSukravahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASSUKRAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasSukravahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASMOOTRAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMootravahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASMOOTRAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMootravahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASMOOTRAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMootravahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASMOOTRAVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasMootravahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASPURESHVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasPureevahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASPURESHVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasPureevahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASPURESHVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasPureevahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASPURESHVAHA:
      return {
        ...state,
        ayurvedicopdExamSrotasPureevahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMSROTASSWEDAVAHA:
      return {
        ...state,
        ayurvedicopdExamSwedavahaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMSROTASSWEDAVAHA:
      return {
        ...state,
        ayurvedicopdExamSwedavahaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMSROTASSWEDAVAHA:
      return {
        ...state,
        ayurvedicopdExamSwedavahaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMSROTASSWEDAVAHA:
      return {
        ...state,
        ayurvedicopdExamSwedavahaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMVIKRUTHIFIELDS:
      console.log("Reducer Updated: ", action.payload.data);
      return {
        ...state,
        ayurvedicopdExamVikruthiFieldsList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMVIKRUTHIFIELDS:
      return {
        ...state,
        ayurvedicopdExamVikruthiFieldsSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMVIKRUTHIFIELDS:
      return {
        ...state,
        ayurvedicopdExamVikruthiFieldsUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMVIKRUTHIFIELDS:
      console.log("🗑 Deleting Entry", action.payload); 
      return {
        ...state,
        ayurvedicopdExamVikruthiFieldsDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMWEALTHFAULT:
      return {
        ...state,
        ayurvedicopdExamWealthFaultList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMWEALTHFAULT:
      return {
        ...state,
        ayurvedicopdExamWealthFaultSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMWEALTHFAULT:
      return {
        ...state,
        ayurvedicopdExamWealthFaultUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMWEALTHFAULT:
      return {
        ...state,
        ayurvedicopdExamWealthFaultDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMWEALTHDUSHYA:
      return {
        ...state,
        ayurvedicopdExamWealthDushyaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMWEALTHDUSHYA:
      return {
        ...state,
        ayurvedicopdExamWealthDushyaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMWEALTHDUSHYA:
      return {
        ...state,
        ayurvedicopdExamWealthDushyaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMWEALTHDUSHYA:
      return {
        ...state,
        ayurvedicopdExamWealthDushyaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMWEALTHFIRE:
      return {
        ...state,
        ayurvedicopdExamWealthFireList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMWEALTHFIRE:
      return {
        ...state,
        ayurvedicopdExamWealthFireSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMWEALTHFIRE:
      return {
        ...state,
        ayurvedicopdExamWealthFireUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMWEALTHFIRE:
      return {
        ...state,
        ayurvedicopdExamWealthFireDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMWEALTHAMA:
      return {
        ...state,
        ayurvedicopdExamWealthAmaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMWEALTHAMA:
      return {
        ...state,
        ayurvedicopdExamWealthAmaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMWEALTHAMA:
      return {
        ...state,
        ayurvedicopdExamWealthAmaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMWEALTHAMA:
      return {
        ...state,
        ayurvedicopdExamWealthAmaDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMWEALTHSOURCES:
      return {
        ...state,
        ayurvedicopdExamWealthSourcesList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMWEALTHSOURCES:
      return {
        ...state,
        ayurvedicopdExamWealthSourcesSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMWEALTHSOURCES:
      return {
        ...state,
        ayurvedicopdExamWealthSourcesUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMWEALTHSOURCES:
      return {
        ...state,
        ayurvedicopdExamWealthSourcesDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMWEALTHFAULTYSOURCES:
      return {
        ...state,
        ayurvedicopdExamWealthFaultySourceList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMWEALTHFAULTYSOURCES:
      return {
        ...state,
        ayurvedicopdExamWealthFaultySourceSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES:
      return {
        ...state,
        ayurvedicopdExamWealthFaultySourceUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES:
      return {
        ...state,
        ayurvedicopdExamWealthFaultySourceDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN:
      return {
        ...state,
        ayurvedicopdExamWealthPlaceofOriginList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMWEALTHPLACEOFORIGIN:
      return {
        ...state,
        ayurvedicopdExamWealthPlaceofOriginSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN:
      return {
        ...state,
        ayurvedicopdExamWealthPlaceofOriginUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN:
      return {
        ...state,
        ayurvedicopdExamWealthPlaceofOriginDeleteStatus: action.payload.success,
      }
    case GETAYURVEDICOPDEXAMWEALTHFACTOR:
      return {
        ...state,
        ayurvedicopdExamWealthFactorList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDEXAMWEALTHFACTOR:
      return {
        ...state,
        ayurvedicopdExamWealthFactorSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDEXAMWEALTHFACTOR:
      return {
        ...state,
        ayurvedicopdExamWealthFactorUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDEXAMWEALTHFACTOR:
      return {
        ...state,
        ayurvedicopdExamWealthFactorDeleteStatus: action.payload.success,
      }
      case GETAYURVEDICOPDPANCHAKRMA:
      return {
        ...state,
        ayurvedicopdPanchakarmaList: action.payload.data,
      }
    case CREATEAYURVVEDICOPDPANCHAKRMA:
      return {
        ...state,
        ayurvedicopdPanchakarmaSaveStatus: action.payload.success,
      }
    case UPDATEAYURVEDICOPDPANCHAKRMA:
      return {
        ...state,
        ayurvedicopdPanchakarmaUpdateStatus: action.payload.success,
      }
    case DELETEAYURVEDICOPDPANCHAKRMA:
      return {
        ...state,
        ayurvedicopdPanchakarmaDeleteStatus: action.payload.success,
      }
    default:
      return state;
  }
}
